import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { TipService } from '../../../services/tip.service';
import {
  NewTipsDialogComponent,
  TipDialogData
} from '../new-tips-dialog/new-tips-dialog.component';
import { ConfirmationDailogsComponent } from '../dailogs/confirmation-dailogs/confirmation-dailogs.component';
import { SpinnerService } from '../../spinner-component/spinner.service';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-new-tips',
  templateUrl: './new-tips.component.html',
  styleUrls: ['./new-tips.component.css']
,
  standalone: false
})
export class NewTipsComponent implements OnInit {
  displayedColumns = [
    'source',
    'version',
    'heading',
    'short_desc',
    'long_desc',
    'action'
  ];
  dataSource = new MatTableDataSource<any>([]);
  pageSize = 8;
  pageIndex = 0;
  totalElements = 0;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private tipService: TipService,
    private dialog: MatDialog,
    private spinner: SpinnerService,
     private snackBar: MatSnackBar, 
  ) { }

  ngOnInit(): void {
    this.loadTips();
  }

  loadTips(): void {
    this.spinner.activate();
    this.tipService.getTips().subscribe(res => {
      try{
        if(res){
          this.spinner.deactivate();
          const tips = (res as any).tips ?? res;
          this.totalElements = (res as any).totalElements ?? tips.length;
          this.dataSource.data = tips;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      }catch(error){
        this.spinner.deactivate();
        this.snackBar.open('Failed to load tip data', 'Close', { duration: 5000 })

      }
    });
  }

  addTip(): void {
    const ref = this.dialog.open<
      NewTipsDialogComponent,
      TipDialogData,
      boolean
    >(NewTipsDialogComponent, {
      width: '600px',
      data: {},
      panelClass: 'custom-white-dialog'
    });
    ref.afterClosed().subscribe(saved => {
      if (saved) this.loadTips();
    });
  }

  editTip(tip: any): void {
    const ref = this.dialog.open<
      NewTipsDialogComponent,
      TipDialogData,
      boolean
    >(NewTipsDialogComponent, {
      width: '600px',
      data: { tip },
      panelClass: 'custom-white-dialog'
    });
    ref.afterClosed().subscribe(saved => {
      if (saved) this.loadTips();
    });
  }

  openDeleteConfirmation(id: number){
    this.dialog.open(ConfirmationDailogsComponent, {
      width: '50%',
      maxWidth:'500px',
      panelClass:'custom-confirm-dialog',
      data: {
        message: 'Are you sure you want to delete this tip?',
        btnText: "Delete",
        onConfirm: () => this.deleteTip(id)
      }
    });
  }

  deleteTip(id: number): void {
    this.tipService.deleteTip(id).subscribe({
      next: () => {
        console.log('[List] deleteTip succeeded');
        this.loadTips();
      },
      error: err => console.error('[List] deleteTip error:', err)
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadTips();
  }

}
